import { useContext } from "react";
import { AddToListProviderContext } from "./AddToListContextProvider.js";
const useAddToListContext = () => {
  const context = useContext(
    AddToListProviderContext
  );
  if (context === void 0 || context === null) {
    throw new Error("useAgent must be used within an AgentProvider");
  }
  return context;
};
export {
  useAddToListContext
};
